
import { Country } from './country.model'

/* User defined models */
export class TextReminder {
    country: Country;
    isNotificationSelected: Boolean;
    mobileNumber: string;
    countryISDCode: string;
}